import {Component} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {CompanyTableService} from './company-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {MatDialog} from '@angular/material/dialog';
import {CompanyFormComponent} from './company-form/company-form.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';

@Component({
    selector: 'app-company',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './company.component.html',
    styleUrl: './company.component.scss'
})
export class CompanyComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН'},
            { name: 'name', title: 'Название' },
        ],
        createButtonLabel: 'Добавить компанию',
        showCreateButton: true,
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'Название компании',
            name: 'name',
        }
    ];

    constructor(
        protected companyTableService: CompanyTableService,
        private dialog: MatDialog

    ) { }

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ companyId: Number(value.data[0]['id']) });
        } else if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
    }

    openDialog(data: { companyId?: number }): void  {
        this.dialog.open(CompanyFormComponent, {
            width: '50%',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.companyTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.companyTableService.updateData(this.tableConfig);
    }
}
